import pageReducer from './reducers';
export { default as pageOperations } from './operations';
export { default as pageTypes } from './types';
export default pageReducer;